module.exports = new __parcel__URL__("softcomputers_appleiie.4d1cf316.jpg").toString();